/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonalReductionRequisitionIncludeFilterItems } from './personalReductionRequisitionIncludeFilterItems';
import { PersonalReductionRequisitionScopeFilter } from './personalReductionRequisitionScopeFilter';


export interface PersonalReductionRequisitionIncludeFilterInner { 
    relation?: PersonalReductionRequisitionIncludeFilterInner.RelationEnum;
    scope?: PersonalReductionRequisitionScopeFilter;
}
export namespace PersonalReductionRequisitionIncludeFilterInner {
    export type RelationEnum = 'employeeDepartmentRelation' | 'company' | 'humanCapitalCompany' | 'activesReductionRequisitions' | 'requisitionStatusHistories' | 'status' | 'createdByUser';
    export const RelationEnum = {
        EmployeeDepartmentRelation: 'employeeDepartmentRelation' as RelationEnum,
        Company: 'company' as RelationEnum,
        HumanCapitalCompany: 'humanCapitalCompany' as RelationEnum,
        ActivesReductionRequisitions: 'activesReductionRequisitions' as RelationEnum,
        RequisitionStatusHistories: 'requisitionStatusHistories' as RelationEnum,
        Status: 'status' as RelationEnum,
        CreatedByUser: 'createdByUser' as RelationEnum
    };
}


